import { DatePipe, DecimalPipe, Location } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import {
  faDownload,
  faEye,
  faListAlt,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { DateTime } from "luxon";
import { Observable, Subscription, of, throwError } from "rxjs";
import { catchError, flatMap, map } from "rxjs/operators";
import * as uuid from "uuid";
import { StructuredOperationFileModel } from "../../../app/model/domain/StructuredOperationFileModel";
import { StructuredOperationModel } from "../../../app/model/domain/StructuredOperationModel";
import { StructuredOperationTypeFileModel } from "../../../app/model/domain/StructuredOperationTypeFileModel";
import { DownloadService } from "../../../app/services/download.service";
import { environment } from "../../../environments/environment";
import { TicketCutoffTypeEnum } from "../../enum/cutoff-type.enum";
import { FileType } from "../../enum/file-type.enum";
import { GroupsEnum } from "../../enum/groups.enum";
import { PrecedentStatusEnum } from "../../enum/precedent-status.enum";
import { ReviewerStatusEnum } from "../../enum/reviewer-status.enum";
import { StructuredOperationAssetsSubtypesEnum } from "../../enum/structured-operation-assets-subtypes.enum";
import { ApprovedAssetsModel } from "../../model/domain/ApprovedAssetsModel";
import {
  TicketStatus,
  TicketType,
  WorkflowStatus
} from "../../model/domain/Entity";
import { FileUpload } from "../../model/domain/File";
import { OperationStructuredType } from "../../model/domain/OperationStructuredType";
import {
  ReviewersDecisionModel,
  ReviewersDecisionStatusEnum,
} from "../../model/domain/ReviewersDecisionModel";
import { StructuredOperationPrecedentModel } from "../../model/domain/StructuredOperationPrecedentModel";
import { AuthService } from "../../services/auth.service";
import { CalendarService } from "../../services/calendar.service";
import { CutoffService } from "../../services/cutoff.service";
import { DialogService } from "../../services/dialog.service";
import { FileService } from "../../services/file.service";
import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";
import { ValidatorService } from "../../services/validator.service";
import { AnnotationComponent } from "../annotation/annotation.component";
import { Roles } from "../auth/auth.role";
import { TicketCutoffPermission } from "../cutoff/ticket-cutoff-type.model";
import { DadosFundoComponent } from "../dados-fundo/dados-fundo.component";
import { FileListTableComponent } from "./file-list-table/file-list-table.component";

@Component({
  selector: "app-operation-structured",
  templateUrl: "./operation-structured.component.html",
  styleUrls: ["./operation-structured.component.scss"],
})
export class OperationStructuredComponent implements OnInit, OnDestroy {
  @Input() ticketId: any = 0;
  @Output() tempTicketId = new EventEmitter<any>();

  @ViewChild("thisForm", { static: true }) public form: NgForm;
  //@ViewChild("thisInput") inputFile: ElementRef;
  @ViewChild("portfolio", { static: true }) fundComponent: DadosFundoComponent;
  @ViewChild("annotation", { static: true })
  annotationComponent: AnnotationComponent;
  @ViewChildren("fileListTable")
  fileListTableComponentList: QueryList<FileListTableComponent>;

  dataChanged: EventEmitter<string>;

  TicketTypeEnum = TicketType;
  WorkFlowStatusEnum = WorkflowStatus;
  navigationSubscription: Subscription;
  groups = GroupsEnum;
  faDownload = faDownload;
  faEye = faEye;
  faTrash = faTrash;
  faListAlt = faListAlt;
  faPlus = faPlus;

  model: StructuredOperationModel;
  isPosting: boolean;
  isEditing: boolean;
  canValidate: boolean;
  tempFiles: File[] = [];
  precendentFile: File[] = [];
  fileList: FileUpload[] = [];
  allFileList: FileUpload[] = [];
  operationTypeList: OperationStructuredType[] = [];
  operationSubTypeList: OperationStructuredType[] = [];
  operationSubTypeFileList: OperationStructuredType[] = [];
  structuredOperationFileAnnotation: StructuredOperationFileModel;
  selectedTypeId: number = null;
  selectedSubTypeId: number = null;
  defaultPage = 1;
  defaultPageSize = 10;
  uploadPageSize: number = this.defaultPageSize;
  uploadTotalPages: number = null;
  uploadTotalItems: number = null;
  uploadListedPages: any[];
  uploadFirstItemOnPage: number;
  uploadLastItemOnPage: number;
  uploadCurrentPage: number = this.defaultPage;
  tempId: any = null;
  roles: number[] = [];
  canShow = true;
  portfolioFundId: number = null;
  newAnnotation: string;
  isCollapsed: boolean = false;
  reviewersDecisionModelList: ReviewersDecisionModel[] = [];
  reviewersDecisionToPrecedentList: ReviewersDecisionModel[] = [];
  reviewerDecisionStatusEnum: ReviewersDecisionStatusEnum;
  precedentList: StructuredOperationPrecedentModel[] = [];
  dataSource = new MatTableDataSource(this.precedentList);
  approvedAssetsList: ApprovedAssetsModel[] = [];
  approvedAssetsDataSource = new MatTableDataSource(this.approvedAssetsList);
  totalApprovedAssetsAmount: number = null;
  totalApprovedAssetsValue: number = null;
  biggestLimitTimestamp: number = 0;
  biggestLimitDate: Date = null;
  pastedValue: String = '';
  isNotProduction = environment.name != 'production';

  ColumnsReviewers = ["groupName", "status"];

  ColumnsPrecedent = [
    "modal",
    "action",
    "responsable",
    "responsableEmailNotification",
    "documents",
    "status",
    "addRow",
  ];

  ColumnsApprovedAssets = [
    "comments",
    "assetName",
    "amount",
    "approvedValue",
    "limitDate",
    "addRow",
  ];

  // TODO: Pegar pelo ENUM pra não ser lista fixa.
  precedentStatusList = [
    {
      id: PrecedentStatusEnum.Approved,
      status: "Aprovado",
    },
    {
      id: PrecedentStatusEnum.Reproved,
      status: "Reprovado",
    },
    {
      id: PrecedentStatusEnum.NoLongerApplies,
      status: "Não se aplica mais",
    },
    {
      id: PrecedentStatusEnum.Waiting,
      status: "Aguardando",
    },
  ];

  reviewersStatusList = [
    {
      id: ReviewerStatusEnum.Approved,
      status: "Aprovado",
    },
    {
      id: ReviewerStatusEnum.ApprovedWithReservation,
      status: "Aprovado com Ressalva",
    },
    {
      id: ReviewerStatusEnum.Reproved,
      status: "Reprovado",
    },
    {
      id: ReviewerStatusEnum.Waiting,
      status: "Aguardando",
    },
  ];

  ColumnsFile: string[] = ["name", "createDate", "createUser", "actions"];

  constructor(
    public calendarService: CalendarService,
    public validator: ValidatorService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private fileService: FileService,
    private service: TicketService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private snackBarService: SnackbarService,
    private router: Router,
    private location: Location,
    private cutoffService: CutoffService,
    private dialogService: DialogService,
    private downloadService: DownloadService,
    private decimalPipe: DecimalPipe,
  ) {
    this.tempId = uuid.v4();
  }

  validators = {
    checkApprovedAssetsList: () =>
      !this.disableApproveAssets()
        ? this.approvedAssetsList.length > 0 &&
          this.approvedAssetsList[0].id != 0
        : true,

    originatorDocument: (value) =>
      this.isOtherAssets() || this.isCreditAsset()
        ? this.validator.validateCPFCNPJ(value)
        : true,

    operationAbstract: (value) => this.coalesce(value).length > 0,
  };

  ngOnInit(): void {
    this.dataChanged = new EventEmitter<string>();
    this.structuredOperationFileAnnotation = new StructuredOperationFileModel();

    this.getOperationType();
    this.getTicket();
    this.getApprovedAssets();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  coalesce(value: any) {
    return value || "";
  }

  canUploadTransfer() {
    const roles = [Roles.CreateTicketStructuredOperations];
    return this.authService.hasRoles(roles);
  }

  getTicket(idBoleta: number = null): void {
    this.model = new StructuredOperationModel();
    const id =
      idBoleta === null ? +this.route.snapshot.paramMap.get("id") : idBoleta;
    this.model.id = id;
    this.ticketId = id;

    if (id) {
      this.service.StructuredOperations.getTicket(id).subscribe((q) => {
        Object.assign(this.model, q);

        this.selectedTypeId =
          this.model.operationTypeFile.structuredOperationAssetId;
        if (this.selectedTypeId != null) {
          this.getOperationSubType(this.selectedTypeId);
        }

        this.selectedSubTypeId =
          this.model.operationTypeFile.structuredOperationAssetSubtypeId;

        if (this.selectedSubTypeId != null) {
          this.getOperationSubTypeFiles(this.selectedSubTypeId);
        }

        this.model.portfolioDocument = this.validator.formatDocument(
          this.model.portfolioDocument
        );

        this.fundComponent.fillComponentFieldsLoad(this.model);
        this.isEditing = true;
        this.canValidate = true;
        this.getReviewersDecision();
        this.getApprovedAssets();
        this.getOperationSubTypeFiles(this.selectedSubTypeId);
        this.setEnable(false);
      });
    } else if (!this.model.statusId) {
      this.model.operationDate = new Date();
    }
  }

  addRow() {
    var auth = this.authService.getAuth();
    this.precedentList.push({
      id: 0,
      precedent: "",
      reviewerGroupId: 0,
      email: "",
      fileId: [],
      precedentStatus: 4,
      ticketId: this.model.id,
      isExternal: false,
      creationPrecedent: auth.username,
    });
    this.dataSource = new MatTableDataSource(this.precedentList);
  }

  createPrecedent(item) {
    if (this.validator.validateEmail(item.email)) {
      if (item.reviewerGroupId == 0) {
        item.isExternal = true;
      }
      
      this.loaderService.addLoader();

      this.service.StructuredOperations.createPrecedent(item).subscribe((p) => {
        Array.from(this.precendentFile).forEach((element) => {
          this.fileService
            .newUploadAttachment(
              element,
              null,
              this.model.id,
              FileType.PrecedentFile,
              this.selectedSubTypeId,
              p.id
            )
            .subscribe((r) => {
              item.fileId.push(r.id);
              
              location.reload();
            });
        });
      });
      
    } else {
      this.snackBarService.open("Preencha um email válido", "ok", {
        verticalPosition: "top",
        horizontalPosition: "right",
      });
    }
  }

  addApprovedAssetRow() {
    this.approvedAssetsList.push({
      id: 0,
      ticketId: this.model.id,
      comments: "",
      assetName: "",
      amount: null,
      approvedValue: null,
      limitDate: null,
    });
    this.approvedAssetsDataSource = new MatTableDataSource(
      this.approvedAssetsList
    );
  }

  createApprovedAsset(item: ApprovedAssetsModel) {
    item.limitDate = new Date(
      item.limitDate.toString().replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
    );

    var yesterdayDate = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate() - 1);

    if (item.limitDate < yesterdayDate) {
      item.limitDate = this.datePipe.transform(
        item.limitDate,
        "dd/MM/yyyy",
        "UTC"
      ) as any;

      return this.dialogService.inform(
        "Data Limite para Operar/Liquidar Inválida!",
        "Data preenchida é anterior a data atual."
      );
    }

    if (item.limitDate.getDay() == 0 || item.limitDate.getDay() == 6) {
      item.limitDate = this.datePipe.transform(
        item.limitDate,
        "dd/MM/yyyy",
        "UTC"
      ) as any;

      return this.dialogService.inform(
        "Data Limite para Operar/Liquidar Inválida!",
        "Data preenchida ocorre no final de semana."
      );
    }

    this.calendarService.getHolidaysList().subscribe((res) => {
      if (res.length > 0) {
        res.forEach((x) => {
          x.date = this.datePipe.transform(x.date, "dd/MM/yyyy", "UTC") as any;
          item.limitDate = this.datePipe.transform(
            item.limitDate,
            "dd/MM/yyyy",
            "UTC"
          ) as any;

          if (item.limitDate == x.date) {
            return this.dialogService.inform(
              "Data Limite para Operar/Liquidar Inválida!",
              "Data preenchida ocorre em um feriado."
            );
          }
        });
      }
    });

    item.amount = this.validator.getNumeric(item.amount);

    this.service.StructuredOperations.createApprovedAsset(item).subscribe(
      (r) => {
        this.getApprovedAssets();
      }
    );
  }

  getApprovedAssets() {
    this.service.StructuredOperations.getApprovedAssets(
      this.model.id
    ).subscribe((res) => {
      this.approvedAssetsList = res;
      this.totalApprovedAssetsAmount = null;
      this.totalApprovedAssetsValue = null;

      this.approvedAssetsList.forEach((item) => {
        this.totalApprovedAssetsAmount += item.amount;
        this.totalApprovedAssetsValue += item.approvedValue;

        var formattedDate = this.datePipe.transform(
          item.limitDate,
          "dd/MM/yyyy",
          "UTC"
        ) as any;

        var dateValues = formattedDate.toString().split('/');
        var dateString = dateValues[2] + dateValues[1] + dateValues[0];
        var timestamp = parseInt(dateString);
        
        if(this.biggestLimitTimestamp < timestamp) {
          this.biggestLimitTimestamp = timestamp;
          this.biggestLimitDate = item.limitDate;
        }

        item.limitDate = formattedDate;
        item.amount = this.decimalPipe.transform(
          item.amount,
          "1.0-8",
          "pt-BR"
        ) as any;
      });

      this.approvedAssetsDataSource = new MatTableDataSource(
        this.approvedAssetsList
      );
    });
  }

  disableApproveAssets() {
    return (
      this.model.statusId != WorkflowStatus.StructuredFinalReviewerDecision
    );
  }

  disableApproveAssetsGroup() {
    return this.authService.hasGroup([this.groups.AdmFiduci]);
  }

  getReviewersDecision() {
    const id = +this.route.snapshot.paramMap.get("id");
    this.service.StructuredOperations.getReviewersDecision(id).subscribe(
      (q) => {
        this.reviewersDecisionModelList = q;
        this.getPrecedentList();
      }
    );
  }

  getPrecedentList() {
    if(this.canViewPrecedent()) {
      const id = +this.route.snapshot.paramMap.get("id");
      this.service.StructuredOperations.getAllPrecedent(id).subscribe((q) => {
        this.precedentList = q;
        this.reviewersDecisionToPrecedentList = this.reviewersDecisionModelList;
        this.reviewersDecisionToPrecedentList.push({
          id: 0,
          groupName: "Usuário Externo",
          groupId: 0,
          reviewersDecisionStatus: 0,
          ticketId: this.model.id,
          userId: 0,
          userName: "",
          workflowId: 0,
        });
        this.dataSource = new MatTableDataSource(this.precedentList);
      });
    }
  }

  canApproveUpload() {
    const roles = [Roles.ApprovePendingApprovalAdm, Roles.ApproveInPreAnalysis];
    return this.authService.hasRoles(roles);
  }

  canEdit() {
    return (
      this.model.statusId == null &&
      this.model.statusDescription == null &&
      this.authService.hasRole(Roles.CreateTicketStructuredOperations)
    );
  }

  setEnable(enabled: boolean = false) {
    setTimeout(() => {
      if (enabled) {
        Object.values(this.form.controls).forEach((c) => {
          c.enable();
        });
      } else if (!this.canEdit()) {
        this.fundComponent.setEnable(false);
        this.annotationComponent.annotationIsDisabled = true;
        Object.values(this.form.controls).forEach((c) => {
          c.disable();
        });
      }
    }, 10);
  }

  // duplicate() {
  //   this.register(this.form, true).subscribe((newTicket) => {
  //     this.snackBarService
  //       .open("Boleta duplicada.", "Visualizar no Monitor", {
  //         verticalPosition: "top",
  //         horizontalPosition: "right",
  //         duration: 6000,
  //       })
  //       .onAction()
  //       .subscribe((a) => {
  //         this.router.navigate([
  //           MenuConstants.Todos,
  //           { ticketId: TicketType.StructuredOperations },
  //         ]);
  //       });
  //   });
  // }

  // canDuplicate() {
  //   const _operationDate = this.datePipe.transform(
  //     this.model.operationDate,
  //     "yyyy-MM-dd"
  //   );
  //   const _duplicateTicketDateLimit = this.datePipe.transform(
  //     new Date(environment.duplicateTicketDateLimit),
  //     "yyyy-MM-dd"
  //   );

  //   return (
  //     this.model.id &&
  //     this.authService.hasRole(Roles.CreateTicketStructuredOperations) &&
  //     !(_operationDate <= _duplicateTicketDateLimit)
  //   );
  // }

  canChangeStatus() {
    return (
      this.model.statusId &&
      this.authService.hasRoles(this.model.statusRequiredRoles) &&
      this.authService.hasGroup(this.model.approvalGroupIds) &&
      !this.sameGroupHasApproved()
    );
  }

  sameGroupHasApproved() {
    return this.authService.hasGroup(this.model.approvedGroupIds);
  }

  getOperationType() {
    this.service.StructuredOperations.getOperationTypes().subscribe(
      (operationList) => {
        this.operationTypeList = operationList;
        this.operationSubTypeList = [];
        this.operationSubTypeFileList = [];
        this.selectedSubTypeId = 0;
      }
    );
  }

  getOperationSubType(selectedTypeId: number) {
    if (this.selectedTypeId != 0) {
      this.service.StructuredOperations.getOperationSubTypes(
        selectedTypeId
      ).subscribe((subTypeOperationList) => {
        this.operationSubTypeList = subTypeOperationList;
        this.operationSubTypeFileList = [];
      });
    }
  }

  getOperationSubTypeFiles(selectedSubTypeId: number) {
    if (this.selectedSubTypeId != 0) {
      this.service.StructuredOperations.getOperationSubTypeFiles(
        selectedSubTypeId
      ).subscribe((subTypeOperationFileList) => {
        this.operationSubTypeFileList = subTypeOperationFileList;
        this.operationSubTypeFileList?.forEach((item) => {
          this.model.operationTypeFile?.typeFileIdList?.forEach((modelItem) => {
            if (item.id == modelItem.structuredOperationAssetSubtypeFileId) {
              if (item.file == null) {
                item.file = this.fileList;
                item.fileId = modelItem.fileId;
              }
              item.file.push(modelItem.file);
              // this.Files.push(item.file);
            }
          });
        });
      });
    }
  }

  changeReviewerStatus(statusId: number, groupId: number) {
    var groupList: number[] = [];
    groupList.push(groupId);
    if (this.authService.hasGroup(groupList)) {
      if (statusId == ReviewerStatusEnum.Reproved) {
        this.reviewerReject(groupId);
      } else {
        this.service.StructuredOperations.changeStatus(
          statusId,
          groupId,
          this.model.id
        ).subscribe((r) => {
          this.snackBarService.open("Status alterado com sucesso!");
        });
      }
    } else {
      this.wrongGroup();
    }
  }

  wrongGroup(): void {
    this.dialogService
      .warningGroup(
        "Grupo Errado",
        "Por favor, faça alterações de status somente no seu grupo."
      )
      .subscribe((result) => {
        this.getReviewersDecision();
      });
  }

  submit(item: OperationStructuredType) {
    this.tempTicketId.emit(this.tempId);

    this.fileService
      .newUploadAttachment(
        this.tempFiles[item.id],
        this.tempId,
        this.ticketId,
        3,
        item.id
      )
      .subscribe((r) => {
        this.structuredOperationFileAnnotation.comment = item.annotation;
        this.structuredOperationFileAnnotation.tempId = this.tempId;
        this.structuredOperationFileAnnotation.ticketId = this.ticketId;
        this.structuredOperationFileAnnotation.subTypeAssetId = item.id;
        this.structuredOperationFileAnnotation.fileId = r.id;
        item.fileId = r.id;
        item.file = [];
        item.file.push(r);

        this.service.StructuredOperations.saveStructuredOperationFileType(
          this.structuredOperationFileAnnotation
        ).subscribe(() => {
          this.fileListTableComponentList.forEach((component) => {
            component.loadFiles();
          });

          this.loadAllFiles();
        });
      });
  }

  openFile(event, fileId) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      this.tempFiles[fileId] = fileList[0];
    }
  }

  openPrecedentFile(event) {
    this.precendentFile = event.target.files;
  }

  showModalComment() {
    this.structuredOperationFileAnnotation.workflowStatusId =
      this.model.statusId;
    this.structuredOperationFileAnnotation.ticketId = this.model.id;
    this.dialogService.operationStructuredCommentDialog(
      this.structuredOperationFileAnnotation
    );
  }

  showModalReservation() {
    this.dialogService.operationStructuredReservation(
      this.model.id,
      this.model.approvalGroupIds
    );
  }

  showModalPrecedent(item) {
    this.dialogService.operationStructuredPrecedentDialog(
      item,
      this.reviewersDecisionModelList
    );
  }

  submitTicket(): void {
    if (
      this.selectedSubTypeId != 0 &&
      this.allMandatoryFilesAreSent()
    ) {
      this.loaderService.addLoader();

      const editing = this.isEditing;

      this.register(this.form)
        .pipe(
          catchError((err) => {
            this.loaderService.removeLoader();

            this.snackBarService.open(err, "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            return throwError(err);
          })
        )
        .subscribe(
          (r) => {
            this.loaderService.removeLoader();

            const msg = editing ? "Boleta alterada." : "Boleta cadastrada.";

            this.snackBarService.open(msg, "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
          },
          () => {}
        );
    } else {
      this.snackBarService.open(
        "Existem arquivos obrigatórios que não foram enviados.",
        "OK",
        {
          verticalPosition: "top",
          horizontalPosition: "right",
        }
      );
    }
  }

  allMandatoryFilesAreSent(): boolean {
    var isValid = true;
    this.operationSubTypeFileList.forEach((f) => {
      if(isValid) {
        var subtypeFile = this.allFileList.find((e) => e.structuredSubtypeFile == f.id);
        if(f.isMandatory && !subtypeFile) {
          isValid = false;
        }
      }
    });

    return isValid;
  }

  loadAllFiles(): Observable<FileUpload[]> {
    this.fileService
      .getAllFilesAttachment(this.tempId, this.ticketId)
      .subscribe((result) => {
        if (result) {
          this.allFileList = result;
          return this.allFileList;
        } else {
          this.allFileList = [];
        }
      });
    return;
  }

  getAllFileList(allFileList: FileUpload[]) {
    allFileList.forEach((component) => {
      this.allFileList.push(component);
    });
  }

  register(
    f: NgForm,
    duplicate: boolean = false
  ): Observable<StructuredOperationModel> {
    const editing = this.isEditing;

    if (!this.canEdit() && !duplicate) {
      return;
    }

    Object.values(f.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });

    this.canValidate = true;

    const errors = this.getErrors();

    this.fundComponent.validatePortfolioFields();
    const fundErrors = this.fundComponent.getErrors();

    if (f.invalid || errors.length > 0 || fundErrors.length > 0) {
      return throwError("Verifique os campos destacados.");
    }

    this.model.operationTypeFile = new StructuredOperationTypeFileModel();
    this.model.operationTypeFile.structuredOperationAssetId = this.selectedTypeId;
    this.model.operationTypeFile.structuredOperationAssetSubtypeId = this.selectedSubTypeId;

    let data = Object.assign({}, this.model);

    data.operationDate = null;
    data.statusId = null;
    data.id = null;
    data.tempTicketId = this.tempId;

    if (duplicate) {
      data.workflowStartDate = null;
      data.workflowEndDate = null;
    }

    data.annotations = this.annotationComponent.annotation;
    data = this.fundComponent.fillPortfolioData(
      data,
      this.fundComponent.portfolio
    );

    const method =
      editing && !duplicate
        ? this.service.StructuredOperations.updateTicket(this.model.id, data)
        : this.service.StructuredOperations.registerTicket(data);

    return method
      .pipe(
        catchError((err) => {
          var error = err.error;
          if (
            error.includes("arquivos")
          ) {
            return throwError(error);
          }

          return throwError("Erro ao cadastrar a boleta.");
        })
      )
      .pipe(
        map((fund: StructuredOperationModel) => {
          if (!editing) {
            this.model.id = fund.id;
            this.model.operationDate = fund.operationDate;
            this.model.statusId = fund.statusId;
            this.model.accountManagerName = fund.accountManagerName;
            this.model.accountManagerDocument = fund.accountManagerDocument;
            this.model.accountManagerId = fund.accountManagerId;
            this.model.ticketCutoffTypeId = fund.ticketCutoffTypeId;

            this.isEditing = true;

            const url = this.router.createUrlTree([this.model.id], {
              relativeTo: this.route,
            });
            this.location.go(url.toString());
          }

          this.ticketId = this.model.id;

          return this.model;
        })
      );
  }

  hasError(prop: string): boolean {
    if (!this.canValidate) {
      return false;
    }

    return !this.validators[prop](this.model[prop]);
  }

  getErrors(): string[] {
    const validationErrors = [];

    Object.keys(this.validators).forEach((k) => {
      if (!this.validators[k](this.model[k])) {
        validationErrors.push(k);
      }
    });

    return validationErrors;
  }

  canCancel() {
    return (
      this.model.id &&
      (!this.model.statusId || this.model.statusId === TicketStatus.Draft) &&
      this.authService.hasRole(Roles.CreateTicketStructuredOperations)
    );
  }

  cancel() {
    return this.dialogService
      .confirm("Cancelar Boleta", "Deseja cancelar esta boleta?")
      .pipe(
        flatMap((ok) => {
          if (ok) {
            return this.service.StructuredOperations.cancelDraftTicket(
              this.model.id
            );
          }

          return of(null);
        })
      )
      .subscribe((res) => {
        if (res) {
          this.model.statusDescription = res.statusDescription;

          Object.values(this.form.controls).forEach((c) => {
            c.disable();
          });

          this.snackBarService.open("Boleta cancelada.", "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });

          this.getTicket(this.model.id);
        }
      });
  }

  async forward(): Promise<void> {
    const cutoffPermission = await this.checkPermission();

    if (!cutoffPermission.isAllowed) {
      this.snackBarService.open(
        this.cutoffService.warningMessage +
          this.cutoffService.dateTimeOffsetToTimeString(
            cutoffPermission.timeLimit
          ),
        "OK"
      );
      return;
    }

    if (
      this.selectedSubTypeId != 0 &&
      this.allMandatoryFilesAreSent()
    ) {
      this.confirmForward().then((ok) => {
        if (!ok) {
          return;
        }
        this.register(this.form)
          .pipe(
            catchError((err) => {
              this.snackBarService.open(err, "OK", {
                verticalPosition: "top",
                horizontalPosition: "right",
              });
              return throwError(err);
            })
          )
          .subscribe(
            (fund: StructuredOperationModel) => {
              this.service.StructuredOperations.forwardTicket(
                fund.id
              ).subscribe((res) => {
                this.model.statusDescription = res.statusDescription;
                this.setEnable(false);

                Object.values(this.form.controls).forEach((c) => {
                  c.disable();
                });

                this.snackBarService.open("Boleta encaminhada.", "OK", {
                  verticalPosition: "top",
                  horizontalPosition: "right",
                });

                location.reload();
              });
            },
            () => {}
          );
      });
    } else {
      this.snackBarService.open(
        "Existem arquivos obrigatórios que não foram enviados.",
        "OK",
        {
          verticalPosition: "top",
          horizontalPosition: "right",
        }
      );
    }
  }

  confirmForward(): Promise<boolean> {
    if (!this.canEdit()) {
      return Promise.resolve(false);
    }

    var textConfirm = 'A boleta não poderá mais ser editada, deseja continuar?';

    if(this.isNotProduction) {
      textConfirm += '<br />ATENÇÃO: ESTE É UM AMBIENTE DE TESTE. NÃO EXECUTE OPERAÇÕES REAIS.';
    }

    return this.dialogService
      .confirm(
        "Encaminhar Boleta",
        textConfirm
      )
      .toPromise()
      .then((result) => {
        if (!result) {
          return false;
        }

        const operationDate = DateTime.fromJSDate(
          new Date(this.model.operationDate.toString())
        );

        if (operationDate.day < DateTime.local().day) {
          return this.dialogService
            .confirm(
              "Boleta Retroativa",
              "A data de operação da boleta será alterada para a data de hoje.",
              "OK",
              "Cancelar"
            )
            .toPromise();
        }

        return true;
      });
  }

  async checkPermission(): Promise<TicketCutoffPermission> {
    let cutoffTypeId = this.model.ticketCutoffTypeId;
    let accountManagerId = this.model.accountManagerId;
    let fundId = this.model.portfolioFundId;

    if (accountManagerId === null) {
      cutoffTypeId = TicketCutoffTypeEnum.StructuredOperations;
      accountManagerId = this.authService.authToken.accountManagerId;
      fundId = this.fundComponent.portfolio.fundId;
    }

    return this.cutoffService.isAvailable(
      cutoffTypeId,
      this.model.id,
      accountManagerId,
      fundId
    );
  }

  approve(): void {
    if (this.model.statusId != WorkflowStatus.StructuredReadyToOperate) {
      this.dialogService
        .confirm("Aprovar Boleta", "Deseja aprovar esta boleta?")
        .subscribe((result) => {
          if (result) {
            this.ticketApprove();
          }
        });
    } else {
      this.dialogService
        .confirm(
          "Encerrar inserção de operações",
          "Deseja encerrar inserção de operações ?"
        )
        .subscribe((result) => {
          if (result) {
            this.ticketApprove();
          }
        });
    }
  }

  private ticketApprove() {
    const errors = this.getErrors();

    if (errors.length > 0) {
      return this.dialogService.inform(
        "Atenção!",
        "Adicione ao menos um ativo aprovado. Caso os campos estejam preenchidos verifique se foi salvo."
      );
    }
    var modelGroups = this.model.approvalGroupIds;
    var auth = this.authService.getAuth();
    var groupRole = auth.groupRoles.find(function (groupRole) {
      return modelGroups.some((x) => x == groupRole.groupId);
    });

    this.service.approve(this.model.id, "", groupRole.groupId).subscribe(() => {
      this.snackBarService.open("Boleta atualizada com sucesso.");
      location.reload();
      // if (this.canSendTransferForLiquidation()) {
      //   this.electronicTransferAvailable();
      // }
    });
  }

  reject(): void {
    this.dialogService
      .reject("Reprovar Boleta", "Deseja reprovar esta boleta?")
      .subscribe((result) => {
        if (result) {
          this.ticketCancel(result.justification);
        }
      });
  }

  reviewerReject(groupId: number): void {
    this.dialogService
      .reject("Reprovar Boleta", "Deseja reprovar esta boleta?")
      .subscribe((result) => {
        if (result) {
          this.ticketCancel(result.justification);
          this.service.StructuredOperations.changeStatus(
            ReviewerStatusEnum.Reproved,
            groupId,
            this.model.id
          ).subscribe((r) => {
            this.snackBarService.open("Status alterado com sucesso!");
          });
        } else {
          this.getReviewersDecision();
        }
      });
  }

  private ticketCancel(justification: string) {
    this.service.reject(this.model.id, justification).subscribe(() => {
      this.snackBarService.open("Boleta atualizada com sucesso.");
      this.getTicket(this.model.id);
    });
  }

  getReviewClass(status: number): string {
    switch (status) {
      case ReviewerStatusEnum.Approved:
        return "approvedClass";
      case ReviewerStatusEnum.ApprovedWithReservation:
        return "reservationClass";
      case ReviewerStatusEnum.Reproved:
        return "reprovedClass";
      case ReviewerStatusEnum.Waiting:
        return "waitingClass";
    }
  }

  isPartnerParticipation() {
    return (
      this.selectedSubTypeId ==
        StructuredOperationAssetsSubtypesEnum.PublicCompany ||
      this.selectedSubTypeId ==
        StructuredOperationAssetsSubtypesEnum.ClosedCompany ||
      this.selectedSubTypeId ==
        StructuredOperationAssetsSubtypesEnum.LimitedCompany ||
      this.selectedSubTypeId ==
        StructuredOperationAssetsSubtypesEnum.SpecialPurposeEntity
    );
  }

  isOtherAssets() {
    return (
      this.selectedSubTypeId ==
        StructuredOperationAssetsSubtypesEnum.JudicialActions ||
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.Precatory
    );
  }

  isRealEstateAsset() {
    return (
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.Realty
    );
  }

  isDebenture() {
    return (
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.Debenture
    );
  }

  isCreditAsset() {
    return (
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.CCB ||
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.CRA ||
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.CRI ||
      this.selectedSubTypeId == StructuredOperationAssetsSubtypesEnum.Debenture
    );
  }

  canViewAttachments() {
    return (
      (((this.canUploadTransfer() && this.canEdit) ||
        this.canApproveUpload()) &&
        this.operationSubTypeFileList.length > 0 || this.canViewPrecedent()) ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredInAnalysis
    );
  }

  onNewAssetQuantityPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');

    pastedText = pastedText.trim();
    pastedText = pastedText.replace('R$ ', '').replace('\r', '').replace('\n', '');

    this.pastedValue = pastedText;
  }

  onNewAssetQuantityInput(event: any, element: any) {
    if(this.pastedValue != null && this.pastedValue.trim() != '') {
      element.amount = this.pastedValue;
      this.pastedValue = null;
    }
  }

  canViewPrecedent() {
    const roles = [
      Roles.ApproveInPreAnalysis,
      Roles.ApproveInAnalysis,
      Roles.ApproveInPreAnalysisOpinion,
      Roles.ApproveInAnalysisOpinion, 
      Roles.ApproveInFinalReviewerDecision,
      Roles.ApproveAwaitingSettlementExternalClearing,
      Roles.ApproveActiveSettlementExternalClearing,
      Roles.ApproveControllershipPending,
      Roles.ApproveInAnalysisReservation
    ];

    return (this.model.statusId == this.WorkFlowStatusEnum.StructuredReadyToOperate ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredFinalReviewerDecision ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredCompleted ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredInAnalysis ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredReservationAnalysis ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredCancelledInReservationAnalysis ||
      this.model.statusId == this.WorkFlowStatusEnum.StructuredCancelledInAnalysis) &&
      this.authService.hasRoles(roles);
  }

  getTransformedTotalAmount() {
    var transformedTotalApprovedAssetsAmount = this.decimalPipe.transform(
      this.totalApprovedAssetsAmount,
      "1.0-8",
      "pt-BR"
    ) as any;

    return transformedTotalApprovedAssetsAmount;
  }

  isCreatorPrecedent(item): boolean {
    var auth = this.authService.getAuth();
    return item.creationPrecedent == auth.username;
  }
}
